import { z } from "zod";

export const SelectExhibitorsSchema = z.object({
  exhibitors: z.array(z.object({ id: z.string(), new: z.boolean() })),
});

export type SelectExhibitorsForm = z.infer<typeof SelectExhibitorsSchema>;

export const defaultSelectExhibitorsValues = {
  exhibitors: [],
};
